/**
 * Destino tras login OAuth en `/` (vacante pública → /?vacante_id=…).
 */

export const PENDING_PUBLIC_APPLY_VACANTE_KEY = 'pending_public_apply_vacante_id';

/** HomeRoute no debe redirigir mientras LoginView reproduce la salida post-OAuth. */
export const LOGIN_EXIT_ANIMATION_UNTIL_KEY = 'login_exit_animation_until';

const LOGIN_EXIT_ANIMATION_MS = 1800;

export function markLoginExitAnimation(
  durationMs: number = LOGIN_EXIT_ANIMATION_MS,
): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(
    LOGIN_EXIT_ANIMATION_UNTIL_KEY,
    String(Date.now() + durationMs),
  );
}

export function isLoginExitAnimationActive(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  const raw = sessionStorage.getItem(LOGIN_EXIT_ANIMATION_UNTIL_KEY);
  if (!raw) return false;
  const until = Number.parseInt(raw, 10);
  if (Number.isNaN(until) || Date.now() >= until) {
    sessionStorage.removeItem(LOGIN_EXIT_ANIMATION_UNTIL_KEY);
    return false;
  }
  return true;
}

export function clearLoginExitAnimation(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(LOGIN_EXIT_ANIMATION_UNTIL_KEY);
}

export function readApplyVacanteIdFromSearch(search: string | URLSearchParams): string | null {
  const params =
    typeof search === 'string'
      ? new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
      : search;

  const raw =
    params.get('vacante_id')?.trim() ||
    params.get('jobId')?.trim() ||
    params.get('job_id')?.trim() ||
    null;

  return raw && raw.length > 0 ? raw : null;
}

export function rememberPendingApplyVacanteId(vacanteId: string | null): void {
  if (typeof sessionStorage === 'undefined') return;
  if (vacanteId) {
    sessionStorage.setItem(PENDING_PUBLIC_APPLY_VACANTE_KEY, vacanteId);
  } else {
    sessionStorage.removeItem(PENDING_PUBLIC_APPLY_VACANTE_KEY);
  }
}

export function consumePendingApplyVacanteId(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  const raw = sessionStorage.getItem(PENDING_PUBLIC_APPLY_VACANTE_KEY)?.trim();
  sessionStorage.removeItem(PENDING_PUBLIC_APPLY_VACANTE_KEY);
  return raw && raw.length > 0 ? raw : null;
}

/** Query actual + respaldo si OAuth devuelve sin query string. */
export function resolveApplyVacanteIdForLogin(
  searchParams: URLSearchParams,
): string | null {
  const fromRouter = readApplyVacanteIdFromSearch(searchParams);
  if (fromRouter) return fromRouter;

  if (typeof window !== 'undefined') {
    const fromWindow = readApplyVacanteIdFromSearch(window.location.search);
    if (fromWindow) return fromWindow;
  }

  if (typeof sessionStorage === 'undefined') return null;
  const pending = sessionStorage.getItem(PENDING_PUBLIC_APPLY_VACANTE_KEY)?.trim();
  return pending && pending.length > 0 ? pending : null;
}

export function resolvePostLoginPath(
  role: string | null | undefined,
  vacanteId: string | null,
): string {
  const normalizedRole = role?.toLowerCase().trim();

  if (normalizedRole === 'admin') return '/admin';
  if (normalizedRole === 'reclutador') return '/recruiter';
  if (normalizedRole === 'pendiente') return '/pendiente';
  if (vacanteId) return `/home/apply/${encodeURIComponent(vacanteId)}`;
  return '/home/dashboard';
}
